import { FC } from 'react'
import { StarRating } from '@expane/nui'

export const RatingCell: FC<{ rating: number }> = ({ rating }) => (
  <div className="flex items-center gap-1">
    <StarRating rating={rating} size="16" />
    <p className="text-secondary-color">{rating}</p>
  </div>
)
